import { render, staticRenderFns } from "./SolicitacaoCpfPassaporteModal.vue?vue&type=template&id=1bb11080&scoped=true&"
import script from "./SolicitacaoCpfPassaporteModal.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoCpfPassaporteModal.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoCpfPassaporteModal.vue?vue&type=style&index=0&id=1bb11080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb11080",
  null
  
)

export default component.exports